import { PnlTimePeriodOption } from 'src/@types/performance';
import { PORTFOLIO_PAGE_TAB_OPTIONS } from 'src/components/PortfolioPage/consts';

export type PortfolioPeriod = Extract<
	PnlTimePeriodOption,
	'24h' | '7d' | '30d' | '90d'
>;

export type PortfolioPageTabValue = 'trade' | 'earn' | 'history' | 'accounts';

export const isPortfolioPageTabValue = (
	value: string
): value is PortfolioPageTabValue => {
	return PORTFOLIO_PAGE_TAB_OPTIONS.some((option) => option.value === value);
};
